<template>
  <div class="page">
    <b-overlay
      :show="loadingJurisdictionsPage"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
      no-wrap
    />
    <div
      class="back-link"
      @click="$router.push({ name: 'Accounts' })"
    >
      <b-icon-chevron-left font-scale="1.3" />
      <span>
        {{ capitalizeFirstLetter($t('words.accountsManagement')) }}
      </span>
    </div>
    <div>
      <div class="top">
        <b-row>
          <b-col class="left-col">
            <span>
              <img
                src="@/assets/icons/territory_map_cadastre.svg"
                alt="Icon files resources"
              >
              {{ jurisdictionsCount }} {{ $tc('words.jurisdiction', jurisdictionsCount) }}
            </span>
          </b-col>
        </b-row>
      </div>
      <div class="content">
        <div class="row">
          <div class="col">
            <div
              class="add-btn ms-0"
              @click="$router.push({ name: 'NewJurisdiction' })"
            >
              <b-icon-plus />
              {{ $t('jurisdictions.add') }}
            </div>
            <JurisdictionsTable
              @loading="$event => loadingJurisdictionsPage = $event"
              @get-data="getData"
              @change-page="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import JurisdictionsTable from '@/app/jurisdiction/components/JurisdictionsTable.vue';

export default {
  name: 'JurisdictionsList',

  components: {
    JurisdictionsTable
  },

  data() {
    return {
      loadingJurisdictionsPage: false
    };
  },

  computed: {
    ...mapState('jurisdiction', [
      'jurisdictionsCount',
      'jurisdictionsList',
      'jurisdictionsListCurrentPage'
    ]),
  },

  created() {
    if (this.jurisdictionsList.length === 0) {
      this.getData(this.jurisdictionsListCurrentPage);
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to && to.name && !to.name.startsWith('Jurisdiction')) {
      this.SET_JURISDICTIONS_LIST_CURRENT_PAGE(1);
    }
    next();
  },

  methods: {
    ...mapMutations('jurisdiction', [
      'SET_JURISDICTIONS_LIST_CURRENT_PAGE'
    ]),
    ...mapActions('jurisdiction', [
      'GET_JURISDICTIONS_LIST'
    ]),

    async getData(page = 1) {
      try {
        this.loadingJurisdictionsPage = true;
        await this.GET_JURISDICTIONS_LIST({ page: page });
        this.loadingJurisdictionsPage = false;
      } catch (err) {
        if (err && err.code && err.code !== 'ERR_CANCELED') {
          this.loadingJurisdictionsPage = false;
        }
      }
    },

    changePage(e) {
      this.SET_JURISDICTIONS_LIST_CURRENT_PAGE(e);
      this.getData(e);
    },
  }
};
</script>

<style lang="less" scoped>
.content {
  margin: 1rem 2.5rem 1rem 2.4rem;
  padding-right: 5px;
}
</style>